import React, {useEffect} from 'react'
import * as serviceWorker from '../serviceWorkerRegistration'
import {Snackbar} from '@mui/material'
import Button from '@mui/material/Button'
import {useLocation} from 'react-router-dom'

export default function ServiceWorkerWrapper() {
  const {pathname} = useLocation()
  const [showReload, setShowReload] = React.useState(false)
  const [waitingWorker, setWaitingWorker] = React.useState<ServiceWorker | null>(null)

  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    setShowReload(true)
    setWaitingWorker(registration.waiting)
  }

  useEffect(() => {
    serviceWorker.register({onUpdate: onSWUpdate})
  }, [])

  useEffect(() => {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((reg) => reg.update()))
  }, [pathname])

  const reloadPage = () => {
    waitingWorker?.postMessage({type: 'SKIP_WAITING'})
    setShowReload(false)
    window.location.reload()
  }

  return (
    <Snackbar
      open={showReload}
      message="A new version is available!"
      onClick={reloadPage}
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      action={
        <Button
          variant="contained"
          color="inherit"
          size="small"
          onClick={reloadPage}
        >
          Reload
        </Button>
      }
    />
  )
}
